var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-navbar-button',{attrs:{"icon":"mdi-bell","count":_vm.primaryItems.length,"primary-items":_vm.primaryItems,"secondary-items":_vm.secondaryItems}})}
var staticRenderFns = []

export { render, staticRenderFns }